<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * The content below * * * * * * * * * * * -->
<!-- * * * * * * * * * * is only a placeholder * * * * * * * * * * -->
<!-- * * * * * * * * * * and can be replaced. * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * Delete the template below * * * * * * * * * * -->
<!-- * * * * * * * to get started with your project! * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<div class="wm-application-view">
  <wms-spinner *ngIf="spinnerService.status$ | async" [caption]="spinnerService.caption"></wms-spinner>
  <wms-header></wms-header>
  <div class="wm-studio-content" tabindex="0">
    <div class="full-height">
      <wms-leftpanel></wms-leftpanel>
      <div class="wm-right-panel-container">
        <router-outlet  ></router-outlet>
      </div>
      <wms-help-panel></wms-help-panel>
    </div>
    <wms-copilot *ngIf="enableCopilot"></wms-copilot>
    <wms-issues *ngIf="issuesService.isEnabled"></wms-issues>
  </div>
</div>

<div class="modal-backdrop guided-tour" *ngIf="showGuidedTour"></div>

<!--Session timeout dialog-->
<wms-dialog id="sessionTimeoutDialog" [content]="sessionTimeoutLoginForm" customClasses="small wm-studio-dialog"></wms-dialog>
<ng-template #sessionTimeoutLoginForm>
  <wms-session-timeout></wms-session-timeout>
</ng-template>
<wms-dialog id="ssoSessionTimeoutDialog" [content]="ssoSessionTimeoutLoginForm" customClasses="small wm-studio-dialog"></wms-dialog>
<ng-template #ssoSessionTimeoutLoginForm>
  <wms-sso-session-timeout/>
</ng-template>
